"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Avatar_1 = require("./Avatar");
exports.default = Avatar_1.default;
//# sourceMappingURL=index.js.map